import { render } from "./localizedTinyEditor.vue?vue&type=template&id=1cdfc688&ts=true"
import script from "./localizedTinyEditor.vue?vue&type=script&lang=ts"
export * from "./localizedTinyEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__